export const urlToFile = async (url: string, name: string, mime?: string) =>
  fetch(url)
    .then((r) => r.blob())
    .then(
      (blobFile) =>
        new File([blobFile], name, {
          type: mime || "image/png",
        })
    );
